export default "__VITE_ASSET__c36e2929__"